import { useEffect } from 'react'

import { WelcomeMessageScope } from '@api'
import { useUnit } from 'effector-react'
import { useNavigate, useParams } from 'react-router'

import EmptyIcon from '@/assets/images/not-found.svg'
import { Button } from '@/components/ui/button.tsx'
import { $creatorId } from '@/models/creators.ts'
import { CreateWelcomeMessagesPage } from '@/modules/creator-settings/welcome-messages/components/create-welcome-messages-page.tsx'
import { WelcomeMessagesPageSkeleton } from '@/modules/creator-settings/welcome-messages/components/welcome-messages-page-skeleton.tsx'
import { setWelcomeMessage } from '@/modules/creator-settings/welcome-messages/models.ts'
import { useGetWelcomeMessageById } from '@/modules/creator-settings/welcome-messages/query/welcome-message-query.ts'
import { AppRoutes } from '@/utils/constants.ts'

export const EditWelcomeMessagePage = () => {
  const redirect = useNavigate()
  const { id } = useParams<{ id: string }>()
  const creatorId = useUnit($creatorId)
  const { data, isFetching } = useGetWelcomeMessageById(
    id,
    WelcomeMessageScope.NEW_FANS,
  )

  const handleRedirect = () => {
    if (!creatorId) {
      return
    }
    redirect(AppRoutes.Creator.Settings.WelcomeMessages.asUrl(creatorId))
  }

  useEffect(() => {
    // TODO: move it effector and request data by routing
    setWelcomeMessage(data || null)
  }, [data])

  if (isFetching) {
    return <WelcomeMessagesPageSkeleton />
  }

  if (!data) {
    return (
      <div className="mt-8 flex flex-col items-center justify-center gap-3 text-center">
        <EmptyIcon />
        <p>You do not have any data</p>
        <Button onClick={handleRedirect}>Go to Welcome Messages</Button>
      </div>
    )
  }

  return <CreateWelcomeMessagesPage />
}
